import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { usePortalAuth } from "@/context/PortalAuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ADMIN_TOKEN_KEY = "bbc_admin_token";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { googleSignIn } = usePortalAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const isAdmin = location.pathname.startsWith("/admin");

    const finish = (path) => {
      window.history.replaceState({}, "", location.pathname);
      navigate(path, { replace: true });
    };

    (async () => {
      if (!sessionId) {
        finish(isAdmin ? "/admin" : "/portal/login");
        return;
      }
      try {
        if (isAdmin) {
          const res = await axios.post(`${API}/admin/google/session`, { session_id: sessionId });
          localStorage.setItem(ADMIN_TOKEN_KEY, res.data.token);
          finish("/admin");
          window.location.reload();
          return;
        }
        const user = await googleSignIn(sessionId);
        finish(user?.is_onboarded ? "/portal" : "/portal/onboarding");
      } catch (error) {
        const detail = error.response?.data?.detail || error.message || "Google sign-in failed";
        toast.error(detail);
        finish(isAdmin ? "/admin" : "/portal/login");
      }
    })();
  }, [location.hash, location.pathname, navigate, googleSignIn]);

  return (
    <div className="min-h-screen bg-[#020617] flex items-center justify-center" data-testid="auth-callback">
      <Loader2 className="animate-spin text-[#D4AF37]" size={28} />
    </div>
  );
}
